import React from "react";

/**
 * Phiếu lập trước đợt 2 (chưa có cách kiểm): các ô đo cứng cũ (GSM, độ dày, D×R×C, mã vạch, thả rơi...)
 * hiện chỉ đọc ở khối "Số đo (dữ liệu cũ)" — chỉ những giá trị có thật.
 */
export function LegacyMeasurements({ rows }: { rows: Array<[string, React.ReactNode]> }) {
  const visible = rows.filter(([, v]) => v !== null && v !== undefined && v !== "" && v !== false);
  if (visible.length === 0) return null;
  return (
    <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50/60 p-3.5" data-testid="qc-legacy-measurements">
      <div className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-600">Số đo (dữ liệu cũ)</div>
      <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 text-xs md:grid-cols-4">
        {visible.map(([label, value]) => (
          <div key={label} className="flex min-w-0 gap-2">
            <span className="shrink-0 text-slate-500">{label}</span>
            <span className="font-mono font-semibold text-slate-800">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

const TEST_LABEL: Record<string, string> = {
  PASSED: "Đạt",
  PASS: "Đạt",
  FAILED: "Không đạt",
  FAIL: "Không đạt",
  WARNING: "Đạt có lưu ý",
  NA: "N/A",
};

export const legacyTestLabel = (v?: string | null) => (v ? TEST_LABEL[String(v).toUpperCase()] || v : null);
export const legacyBarcodeLabel = (v?: string | null) =>
  v ? (String(v).toUpperCase() === "NA" ? "N/A" : String(v).replace(/^ANSI_/, "Hạng ")) : null;
